import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import CloseIcon from "src/components/icons/Close";
import { toggleGarageDrawer } from "src/store/actions/garageDrawer";

const CloseButton = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(toggleGarageDrawer());
        history.push("/my-garage", history.location.state);
    };
    return (
        <span
            style={{ float: "right", marginRight: "10px", marginTop: "-10px", cursor: "pointer" }}
            onClick={handleClose}
        >
            <CloseIcon />
        </span>
    );
};
export default CloseButton;
